export default "__VITE_ASSET__2jJAlp6x__"